import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'

import type { SchemaAttributes } from '../types.js'

import type { MockServer } from './server.js'

export type ZendeskSettingsData = SchemaAttributes<'ZendeskSettings'>

export const model = Model as ModelDefinition<ZendeskSettingsData>

export const factory = Factory.extend<ZendeskSettingsData>({
  // `department_id` misses in responses, but the schema lists it
  department_id: 1,
  show_support_chat: true,
  show_support_chat_history: true,
})

export function routes(server: MockServer) {
  server.get('/zendesk/settings', (schema) => schema.first('zendeskSettings'))
}

export function seeds(server: MockServer) {
  server.create('zendeskSettings', {
    show_support_chat: true,
    show_support_chat_history: true,
  })
}
